package com.bikompanion.domain

import kotlin.coroutines.cancellation.CancellationException

/**
 * Like `runCatching`, but lets cancellation through.
 *
 * `runCatching` swallows [CancellationException] along with everything else, so a request
 * that was merely abandoned — the screen left, the effect restarted, the page reloaded —
 * would be reported as a load failure and would keep the cancelled coroutine alive.
 */
suspend fun <T> catchingRequest(block: suspend () -> T): Result<T> =
    try {
        Result.success(block())
    } catch (cancellation: CancellationException) {
        throw cancellation
    } catch (error: Throwable) {
        Result.failure(error)
    }
